export default __webpack_public_path__ + "static/media/pattern.0b921a80.png";